export default __webpack_public_path__ + "static/media/my-banner.c20e1448.jpg";